<template>
  <v-container grid-list-md fluid>
    <!-- Dialog Email -->
    <v-dialog v-model="dialogEmailVisible" max-width="500px">
      <v-card>
        <v-card-text>
          <v-checkbox
            :true-value="1"
            :false-value="0"
            v-model="report.sendEmail"
            label="Enviar o Relatório por e-mail ao final do processamento?"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="downloadItem">Confirmar</v-btn>
          <v-btn @click="dialogEmailVisible = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap justify-space-between>
      <v-flex xs12 sm2>
        <v-btn
          color="primary"
          @click="refreshEmpresas(2)"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 sm2>
        <quadro-societario
          :condominio_id="condominio_id"
          :values="quadro_societario"
          :socios="items"
          @updateSocios="updateSocios"
        />
      </v-flex>

      <v-flex xs12 sm4>
        <v-layout justify-space-between align-left>
          <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
          <v-checkbox label="Apenas Ativos" v-model="apenasAtivos" @change="filtrarItens" />
        </v-layout>
      </v-flex>
      
      <v-flex xs12 sm1>
        <v-menu offset-y>
          <v-btn slot="activator" icon class="ml-2" title="Relatórios">
            <v-icon>description</v-icon>
          </v-btn>
          <v-list>
          <!-- PDF -->
          <v-list-tile @click="exportReport(1)">
            <v-list-tile-action>
              <v-icon color="red darken-1">picture_as_pdf</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Relatório em PDF</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Excel -->
          <v-list-tile @click="exportReport(2)">
            <v-list-tile-action>
              <v-icon color="green darken-2">table_chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Relatório em Excel</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        </v-menu>
      </v-flex>
    </v-layout>

    <!--Index-->
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="elevation-1"
        rows-per-page-text="Registros por página"
        :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
        no-data-text="Não existem registros"
        no-results-text="Nenhum registro encontrado"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.pessoa ? props.item.pessoa.id_texto : " " }}</td>
          <td>{{ props.item.inicialporcentagem | formatPercentage }}%</td>
          <td>{{ props.item.porcentagem | formatPercentage }}%</td>
          <td>{{ props.item.data | formatDate }}</td>
          <td>
            <v-checkbox
              v-model="props.item.ativo"
              color="primary"
              @click.native="editValue(entity, props.item.id, props.item)"
            ></v-checkbox>
          </td>
          <td align="center">
            <v-btn
              icon
              class="mx-0"
              @click="refreshEmpresas(3, props.item)"
              :disabled="!hasCondominioAccess(entity, 'update')"
            >
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
              @click="deleteItem(props.item)"
              :disabled="!hasCondominioAccess(entity, 'delete')"
            >
              <v-icon color="pink">delete</v-icon>
            </v-btn>

            <v-tooltip top>
              <v-menu slot="activator" offset-y>
                <v-btn slot="activator" icon class="ml-2" title="Relatórios">
                  <v-icon color="indigo">library_books</v-icon>
                </v-btn>
                <v-list>
                  <!-- PDF -->
                  <v-list-tile @click="handleClick(props.item, 0)">
                    <v-list-tile-content>
                      <v-list-tile-title>Relatório Simples</v-list-tile-title>
                      <v-list-tile-sub-title>Apresentar apenas os bens rurais que sofreram alteração no ano-calendário</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <!-- Excel -->
                  <v-list-tile @click="handleClick(props.item, 1)">
                    <v-list-tile-content>
                      <v-list-tile-title>Relatório Completo</v-list-tile-title>
                      <v-list-tile-sub-title>Apresentar todos os bens rurais, independentemente de alteração no ano</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <!-- Último relatório gerado -->
                  <v-list-tile
                    v-if="props.item.has_report"
                    :href="`${api}reports/${props.item.pessoa.id_texto}.pdf`"
                    target="_blank"
                  >
                    <v-list-tile-title>Visualizar o último Relatório gerado</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <span>Relatório para Declaração de Ajuste</span>
            </v-tooltip>
            <!-- 
            <v-btn icon class="mx-0" @click="exportDbk(props.item, $event)">
              <v-icon color="orange">share</v-icon>
            </v-btn> -->
          </td>
        </template>
        <template slot="footer">
          <td colspan="1">
            <strong>Porcentagem Total</strong>
          </td>
          <td colspan="1">
            <strong>{{ somatorios.inicialporcentagem }}%</strong>
          </td>
          <td colspan="4">
            <strong>{{ somatorios.porcentagem }}%</strong>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-flex>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  name="pessoa_id"
                  v-model="editedItem.pessoa_id"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('pessoa_id')"
                  :data-vv-as="translate('table.' + entity + '.field.pessoa_id')"
                  :label="translate('table.' + entity + '.field.pessoa_id')"
                  :items="dynamicPessoas"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 md6>
                <p-money
                  :disabled="this.view == 2"
                  name="porcentagem_inicial"
                  :label="translate('table.' + entity + '.field.porcentagem_inicial') + ' (Usar quadro societário)'"
                  v-model="editedItem.porcentagem_inicial"
                  :v_validate="'positiveNumber|max_value:100'"
                  custom_preffix=""
                ></p-money>
              </v-flex>

              <!-- <v-flex xs12 md6>
                <p-money custom-suffix="%" custom-preffix="" :custom-precision="15"  v-model="editedItem.porcentagem_inicial"></p-money>
              </v-flex> -->
              <v-flex xs12 md6>
                <p-date
                  name="data"
                  :label="translate('table.' + entity + '.field.data')"
                  v-model="editedItem.data"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('data')"
                  :v_validate="'required|currentYear:' + $auth.user().anobase.id_texto"
                  :data_vv_as="translate('table.' + entity + '.field.data')"
                ></p-date>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  color="primary"
                  :label="translate('table.' + entity + '.field.ativo')"
                  v-model="editedItem.ativo"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";
import acl from "./../../mixin/acl";
import PMoney from "../shared/PMoney";
import QuadroSocietario from "./QuadroSocietario";
import Decimal from "decimal.js";

export default {
  components: {
    PDate,
    PMoney,
    QuadroSocietario,
  },
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_pessoa",
    full_pessoas: [],
    dynamicPessoas: [],
    items: [],
    itemsQuadro: [],
    pagination: {
      rowsPerPage: -1,
    },
    dialogEmailVisible: false,
    report: {
      selectedItem: null,
      type: null,
      sendEmail: 0,
    },
    api: process.env.API,
    apenasAtivos: true,
  }),
  name: "Pessoa",
  props: ["condominio_id", "values", "quadro_societario", "pessoas", "conexoes"],
  created() {
    this.items = this.values;
    this.full_pessoas = [...this.pessoas, ...this.conexoes];
    this.editedItem = {
      condominio_id: this.condominio_id,
      porcentagem_inicial: 0,
      ativo: true,
      data: "",
    };
    this.defaultItem = {
      condominio_id: this.condominio_id,
      porcentagem_inicial: 0,
      ativo: true,
      data: "",
    };
    this.itensOriginais = [...this.items];
    this.filtrarItens();
  },
  methods: {
    filtrarItens() {
      if (this.apenasAtivos) {
        this.items = this.items.filter((item) => item.ativo);
      } else {
        this.items = this.itensOriginais;
      }
    },
    updateSocios(socios) {
      this.items = socios;
    },
    openDialogQuadro() {
      this.dialogQuadroVisible = true;
    },
    closeDialogQuadro() {
      this.dialogQuadroVisible = false;
    },
    handleDialogButtonClick() {
      // Lógica para lidar com o clique do botão no diálogo
    },
    handleDialogFooterButtonClick() {
      // Lógica para lidar com o clique do botão no footer do diálogo
    },

    handleClick(selectedItem, type) {
      this.report.selectedItem = selectedItem;
      this.report.type = type;
      this.dialogEmailVisible = true;
    },
    refreshEmpresas(tela, obj = {}) {
      let remove;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map((a) => a.pessoa_id);
          break;
        case 3: {
          this.editItem(obj);
          remove = this.items.map((a) => {
            if (a.pessoa_id !== this.editedItem.pessoa_id) {
              return a.pessoa_id;
            }
          });
          remove.push(this.$auth.user().pessoa_id);
          break;
        }
      }
      this.dynamicPessoas = this.full_pessoas.filter((item) => !remove.includes(item.id));
    },
    downloadItem(item, bemdireito_completo = false, event) {
      if (!this.report.sendEmail) this.$store.commit("loader/change_dialog", true);
      else {
        this.dialogEmailVisible = false;

        this.$store.commit("snackbar/change_values", {
          text: "O relatório solicitado está sendo gerado e será enviado para seu e-mail assim que finalizado.",
          color: "info",
          dialog: true,
          timeout: 5000,
        });
      }

      this.$http
        .get(
          `report/declaracao_ajuste/${this.report.selectedItem.id}/0/${this.report.type}/0/${this.report.sendEmail}`
        )
        .then(
          (res) => {
            let { pdfname } = res.data;

            window.open(process.env.API + "reports/" + pdfname, "_blank");

            this.$store.commit("loader/change_dialog", false);

            if (this.report.sendEmail && "Notification" in window) {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  const notification = new Notification("Renderização concluído", {
                    body: "Seu relatório está pronto! Confira agora mesmo em seu e-mail.",
                    icon: "/static/img/logo.png",
                  });
                }
              });
            }

            this.report.sendEmail = 0;
          },
          (error) => {
            this.$store.commit("loader/change_dialog", false);
            this.$store.commit("snackbar/change_values", {
              text:
                error.body.message ||
                "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
              color: "error",
              dialog: true,
            });
          }
        );
    },
    // exportDbk (item, event) {
    //   this.$store.commit('loader/change_dialog', true)
    //   this.$http.get(`export/dbk/${item.id}/0`, {responseType: 'arraybuffer'}).then(res => {
    //     let blob = new Blob([res.data], {type: res.headers.get('content-type')})
    //     let link = document.createElement('a')
    //     link.href = window.URL.createObjectURL(blob)
    //     link.download = `${item.pessoa.cpf_cnpj.replace(/\D/g, '')}-IRPF-A-${this.$auth.user().anobase.id_texto + 1}-${parseInt(this.$auth.user().anobase.id_texto)}-ORIGI.DBK`
    //     link.click()
    //     this.$store.commit('loader/change_dialog', false)
    //   }, () => this.$store.commit('loader/change_dialog', false)
    //   )
    // }
    // type 1 = pdf 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`report/report_details/${this.condominio_id}`, {"type": type, "table": "condominio_pessoa", "search": this.search, "apenasAtivos": this.apenasAtivos}).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          const _this = this;
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.pessoa_id"),
          value: "pessoa.id_texto",
          width: "40%",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.porcentagem_inicial") +
            " " +
            this.$auth.user().anobase.id_texto +
            " %",
          value: "inicialporcentagem",
          width: "15%",
        },
        {
          text:
            this.translate("table." + this.entity + ".field.porcentagem") +
            " " +
            this.$auth.user().anobase.id_texto +
            " %",
          value: "porcentagem",
          width: "15%",
        },
        {
          text: this.translate("table." + this.entity + ".field.data"),
          value: "data",
          width: "10%",
        },
        {
          text: this.translate("table." + this.entity + ".field.ativo"),
          value: "ativo",
          width: "5%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ];
    },
    headersQuadro: function () {
      return [{ text: "Data" }, { text: "Descrição" }];
    },
    somatorios: function () {
      return this.items.reduce(
        (acc, item) => {
          acc.inicialporcentagem = Decimal(acc.inicialporcentagem)
            .plus(item.inicialporcentagem)
            .toDP(15);
          acc.porcentagem = Decimal(acc.porcentagem).plus(item.porcentagem).toDP(15);
          return acc;
        },
        { inicialporcentagem: 0, porcentagem: 0 }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/Pessoa.vue